<template>
  <div class="loader">
    <div class="lds-dual-ring"></div>
  </div>
</template>

<script>
export default{
}
</script>

<style lang="scss" scoped>
.loader{
  @include box(100%, 100%, absolute, 0, 0, null, null, 0, $loader);
  @include flex(center, center, row);
  z-index: 999;
  .lds-dual-ring {
    display: inline-block;
    @include size(1.6vw, 1.6vw);
  }
  .lds-dual-ring:after {
    content: " ";
    display: block;
    @include box(1vw, 1vw, null, null, null, null, null, 50%, null);
    @include margin(0, 0, 0, 0);
    border: 0.3vw solid $loaderBorder;
    border-color: $loaderBorder transparent $loaderBorder transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }
  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
